<template>
  <div class="main-wrapper authendication-pages">
    <div class="content blur-ellipses">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-6 mx-auto vph-100 d-flex align-items-center">
            <div class="forgot-password w-100">
              <header class="text-center forgot-head-title">
                <router-link to="/">
                  <img src="@/assets/img/logo_red.png" class="img-fluid" alt="Logo" />
                </router-link>
              </header>
              <div class="shadow-card">
                <h2>Quên mật khẩu</h2>
                <p>Nhập Email đã đăng ký</p>
                <!-- Login Form -->
                <form @submit.prevent="submitForm">
                  <div class="form-group">
                    <div class="group-img">
                      <i class="feather-mail"></i>
                      <input type="text" class="form-control" placeholder="Email" />
                    </div>
                  </div>
                  <router-link to="/"
                    class="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center">Gửi<i
                      class="feather-arrow-right-circle ms-2"></i></router-link>
                </form>
                <!-- /Login Form -->
              </div>
              <div class="bottom-text text-center">
                <p>Bạn đã nhớ mật khẩu? <router-link to="/">Đăng nhập!</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    submitForm() {
      this.$router.push("/");
    },
  },
}
</script>